<div class="smart-app-launch-selector">
  <label id="launch-on-boot-label" class="launch-label">{{
    "COMPONENTS.SMART_APPS.LAUNCH_ON_BOOT.LABEL" | translate
  }}</label>
  <mat-radio-group
    class="launch-radio-group"
    aria-labelledby="launch-on-boot-label"
    [value]="launchAppId"
    (change)="onSelect($event.value)"
  >
    <mat-radio-button [value]="null" color="primary">{{
      "COMPONENTS.SMART_APPS.NONE.LABEL" | translate
    }}</mat-radio-button>
    <mat-radio-button
      *ngFor="let app of apps"
      [value]="app.id"
      color="primary"
      >{{ app.name }}</mat-radio-button
    >
  </mat-radio-group>
</div>
